import React from "react";

function Services() {
  return (
    <section className="services" id="services">
      <h2>Our Services</h2>
      <div className="service-list">
        <div className="service-item">
          <h3>Deep Tissue Massage</h3>
          <p>
            Targets chronic muscle tension and knots using slow, deep pressure,
            combined with trigger point therapy to promote long-term relief and
            melt pain away.
          </p>
        </div>
        <div className="service-item">
          <h3>Sports Massage</h3>
          <p>
            Ideal for athletes and active individuals to combat soreness,
            prevent injury, and improve performance.
          </p>
        </div>
        <div className="service-item">
          <h3>Swedish Relaxation</h3>
          <p>
            Relax and unwind with long, gliding strokes that reduce stress,
            improve circulation, and promote deep relaxation.
          </p>
        </div>
        <div className="service-item">
          <h3>Lymphatic Massage</h3>
          <p>
            This modalitly targes the lymphnodes and lymphatic capillaries to
            help drainage, reduce swelling, and promote healing.
          </p>
        </div>
        <div className="service-item">
          <h3>Myofascial Release</h3>
          <p>
            Myofascial Release uses slow, sustained pressure on connective
            tissue to release muscle restrictions, restore balance, and ease
            chronic discomfort.
          </p>
        </div>
        <div className="service-item">
          <h3>Full Body Stretch Massage</h3>
          <p>
            Through guided, assisted stretches, this massage increases mobility,
            reduces stiffness, and restores natural alignment.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;
